import { Store as VuexStore, CommitOptions, DispatchOptions, Module } from 'vuex'

// TODO: How to surpass cyclical dependency linting errors cleanly?
import { RootState } from '@/store'
import { mutations, Mutations } from './mutations'
import { actions, Actions } from './actions'
import type { PermissionState } from './state'
import { state } from './state'
import { PermissionActionType } from '@/store/modules/permission/action-types'

export { PermissionState }

export type PermissionStore<S = PermissionState> = Omit<VuexStore<S>, 'getters' | 'commit' | 'dispatch'> & {
  commit<K extends keyof Mutations, P extends Parameters<Mutations[K]>[1]>(key: K, payload: P, options?: CommitOptions): ReturnType<Mutations[K]>
} & {
  dispatch<K extends keyof Actions>(key: PermissionActionType.ACTION_SET_ROUTES, payload: string, options?: DispatchOptions): ReturnType<Actions[K]>
}
export const store: Module<PermissionState, RootState> = {
  state,
  mutations,
  actions,
}
